const translate = {
  portugues: {
    title: 'Programa de Afiliados',
    subTitle: 'Confira abaixo as respostas para as perguntas mais frequentes de nossos parceiros:',
    list: [
      {
        title: 'O que é um Afiliado?',
        subtitle: `Nosso Programa de Afiliados permite que você coloque um link do seu website para o nosso. A cada vez que um usuário clica no link e assina o Bella da Semana, você recebe uma comissão de 50% do valor da assinatura e das renovações, durante 12 meses. Fica bem fácil de obter ganhos rápidos e sem custos, incrementando o lucro de seu site.`
      },
      {
        title: 'Por que eu deveria me cadastrar?',
        subtitle: `Nós permitimos que você tenha receitas adicionais para o seu site com mínimo esforço. Nós cuidamos de todas as ´complicações´: processar as assinaturas, contratos e atendimento ao cliente. Tudo o que você tem a fazer é colocar nosso banner no seu site - como você provavelmente já faz - criando uma nova fonte de renda a mais.`
      },
      {
        title: 'De quanto é a minha comissão?',
        subtitle: `Nós temos a melhor comissão do mercado! Como parceiro Bella da Semana, você recebe 50% do valor de cada nova assinatura gerada pelo seu site, que pode ser de um, três, seis ou 12 meses. Além disso, diferente de outros Programas de Afiliados, você é pago mensalmente.`
      },
      {
        title: 'Como posso ter controle sobre quanto em comissões estou ganhando?',
        subtitle: `Nós desenvolvemos um sistema para lhe garantir toda a segurança possível. Através de um site especial localizado em www.belladasemana.com.br/afiliado você poderá rastrear o desempenho de seu link, incluindo: impressões, cliques, taxa de conversão, produtos mais vendidos, assinaturas e comissões. Tudo atualizado diariamente!`
      },
      {
        title: 'Meu website está fora Brasil, ainda posso participar?',
        subtitle: `Bella da Semana é um site internacional, assim como nosso Programa de Afiliados. Nós estamos perfeitamente preparados para afiliados estrangeiros.`
      },
      {
        title: 'Como é feito o pós venda?',
        subtitle: `Todas as assinaturas são processadas pelo Bella da Semana e nós cuidamos de todo o pós venda e quaisquer assuntos sobre atendimento ao cliente - você não precisa se preocupar com nada.`
      }
    ],
    sunscribeTitle:
      'Para dar início ao Programa de Afiliados Bella da Semana preencha a ficha cadastral abaixo',
    subscribeNameEnterprise: 'Nome da empresa',
    subscribeName: 'Pessoa para contato',
    subscribeNumber: 'Fone',
    subscribeMail: 'E-mail para Login/Contato',
    subscribePassword: 'Senha',
    subscribePasswordConfirm: 'Confirme a senha',
    subscribeUrl: 'URL do website',
    subscribeButton: 'Enviar',
    failSend: 'Falha ao enviar formulário!',
    msgClose: 'Fechar',
    msgTitle1: 'Erro',
    msgTitle2: 'Aviso',
    generM: 'Sr',
    generF: 'Sra',
    titleTermsUse: 'TERMOS E CONDIÇÕES',
    aceitlabel: 'Aceito os Termos ',
    imgHome: 'https://api.belladasemana.com.br/storage/br/partner-fluxo-br.png',
    imgFooter: 'https://api.belladasemana.com.br/storage/br/afiliate-bottom-opcs.png',
    msgSuccess:
      'Sua solicitação para fazer parte do Programa de Afiliados está em análise.<br>Em breve entraremos em contato com você. Aguarde!',
    terms: `<p>
    <b>Programa Afiliados - Termos e Condições</b>
</p>
<p>
    O
    presente acordo contém os temos e condições
    completos que se aplicam à sua participação como
    Afiliado de Bella Entretenimento Ltda. (Bella da Semana) e o
    estabelecimento de links de seu site para o nosso, localizado em
    "Belladasemana.com.br". Ao submeter um formulário
    candidatando-se ao Programa, você confirma ter lido o presente
    instrumento e estar submetido a seus termos e condições.
</p>
<p>
    Condições:
</p>
<p>
    <u><b>1.
        Submissão e adesão ao Programa de Afiliados de Bella da
        Semana</b>
    </u>
</p>
<p>
    Para
    tornar-se um Afiliado Bella da Semana, você deve submeter um
    formulário preenchido a nossa apreciação. Nós
    avaliaremos sua candidatura e o notificaremos a respeito de sua
    aceitação ou rejeição em tempo hábil.
    Nós nos reservamos o direito de rejeitar sua candidatura caso
    determinemos (por nossa própria discrição) que
    seu site não seja desejável como afiliado. Sites
    indesejáveis incluem, mas não se limitam a, sites que
    promovam violência, discriminação, atividades
    ilegais, tenham nome que se pareça com o nome "Bella"
    ou de qualquer maneira viole direitos de propriedade intelectual ou
    de patentes.&nbsp;
</p>
<p>
    Caso
    rejeitemos sua candidatura, você pode tentar novamente quando
    quiser, num futuro próximo. Ademais, nós nos reservamos
    o direito de terminar este Acordo caso determinemos que seu site ou o
    uso de qualquer referência seja inapropriado ou seja de
    qualquer maneira impróprio para o Programa de Afiliados de
    Bella.&nbsp;&nbsp;
</p>
<p><u><b>2.
    Promoção&nbsp;</b>
</u><br><br><br>
</p>
<p>
    A
    chave para operar um Afiliado de sucesso é estabelecer link
    gráficos e textuais proeminentes (cada um desses links às
    vezes referido aqui como “links” ou individualmente como
    “link”), de seu site para o nosso site em
    www.belladasemana.com.br . Os links servirão para identificar
    seu site como um membro de nosso Programa de Afiliados e estabelecerá
    um link de seu site para o nosso. Nós disponibilizaremos para
    você um ou mais do seguinte tipo de links:
</p>
<ul>
    <li>
        <p>
            Link
            para belladasemana.com.br: você pode colocar um link geral em
            seu site para a nossa homepage em www.belladasemana.com.br. Nós
            fornecemos guidelines e a arte gráfica para linkar seu site
            ao nosso, incluindo banners e buttons.
        </p>
    </li>
    <li>
        <p>
            Você
            pode escolher de 5 a 6 fotos da sessão aberta para promover o
            conteúdo Bella da Semana em seu Site.
        </p>
    </li>
    <li>
        <p>
            Você
            pode também ter vídeo teasers Bella, mediante pedido
            ao seu contato no site. &nbsp;&nbsp;
        </p>
    </li>
</ul>
<p>
    Ao
    utilizar os links, você concorda em cooperar completamente
    conosco a fim de estabelecer e manter tais links. Você também
    concorda em exibir em seu site tais elementos gráficos e
    textuais (indicando um link) fornecidos por nós e você
    substituirá tais imagens por qualquer outra fornecida pelo
    Bella de tempos e tempos durante a duração deste.<br>Você
    não poderá, a qualquer tempo, exibir ou divulgar
    produtos do Bella, de qualquer maneira ou em qualquer meio de
    comunicação, sem identificá-los como
    pertencentes ao Bella.<br>Você não poderá, a
    qualquer tempo, descrever seu site como o “oficial”,
    “exclusivo”, “preferido”, ou qualquer termo
    semelhante, de Bella; nem criar um design que seja tão similar
    ao de Bella, criando qualquer tipo de confusão, incerteza ou
    mal entendido.&nbsp;<br>Você não poderá, a
    qualquer tempo, alegar propriedade sobre qualquer produto ou marca
    pertencente ao Bella ou renomeá-los de qualquer maneira.
</p>
<p>
    O
    uso de correspondência não solicitada ou spam com a
    finalidade de promoção de Bella da Semana é
    estritamente proibido. Se você se utilizar de spam para
    promover nossos serviços, será notificado de que não
    é mais parte do nosso Programa e todas as comissões
    pendentes serão retidas.
</p>
<p>
    Todos
    os Sites Afiliados devem exibir imagens gráficas ou textuais
    proeminentemente em sessões relevantes de seu site. Todos os
    links devem ser modificados e/ou expandidos de tempo em tempos
    durante a participação no Programa. Cada link que
    conecte usuários do seu site para a área pertinente&nbsp;
    do nosso site não vai alterar de maneira alguma a aparência
    ou funcionalidade de nosso site.<br>Nós seremos responsáveis
    pelo fornecimento de links de seu site para o nosso. Nós
    seremos os únicos responsáveis pelo processamento de
    cada assinatura seguindo um links especial de seu site, rastreando o
    volume de assinaturas geradas através de seu link e pelo
    fornecimento de informações a respeito de estatísticas
    de assinaturas. Nós seremos responsáveis por todo o
    processo de assinatura, incluindo pagamentos, cancelamentos e
    serviços relacionados ao cliente.
</p>
<p>
    <u><b>3.
        Conteúdo Customizado</b>
    </u>
</p>
<p>
    "Conteúdo
    Customizado" significa todo o conteúdo textual, pictórico
    e/ou gráfico criado por ou em nome do representante afiliado,
    descrevendo ou referindo-se aos produtos Bella da Semana e
    autorizados por escrito pelo Bella da Semana.
</p>
<p>
    Antes
    do Afiliado usar qualquer conteúdo customizado, deve fornecer
    amostras em formato eletrônico deste conteúdo ao Bella
    da Semana ao mesmo tempo que submeter um pedido de autorização
    por escrito. Bella da Semana reserva-se o direito de negar o
    consentimento de uso a sua própria discrição por
    qualquer eventual razão. Se a Bella da Semana não
    aprovar o conteúdo customizado por escrito em 10 (dez) dias
    úteis depois da submissão do pedido, este deve ser
    considerado rejeitado. O afiliado pode submeter pedidos revisados
    para aprovação depois de tê-los rejeitados por
    Bella da Semana. O Bella da Semana pode rever seu posicionamento e
    aprovar ou rejeitar submissões a qualquer tempo sem
    necessidade de justificar-se. Você concorda em não usar
    o conteúdo Customizado de outros Afiliados ou parceiros de
    Bella da Semana sem sua respectiva aprovação por
    escrito, além da aprovação de Bella da Semana.&nbsp;
</p>
<p>
    <u><b>4.
        Outras Oportunidades e Responsabilidades dos Sites Afiliados</b>
    </u>
</p>
<ul>
    <li>
        <p>
            Exibição
            Proeminente de Links: se você garante e concorda em participar
            de nosso Programa de Afiliados, você deve exibir Links,
            fornecidos pelo Bella, pelo seu site – de acordo com o que
            achar conveniente e com nossa aprovação.
        </p>
    </li>
    <li>
        <p>
            Concursos
            e promoções: Bella irá, de tempos em tempos,
            fornecer material promocional para seus usuários, membros ou
            visitantes. Nós o notificaremos com antecedência para
            que possa fazer as adequações necessárias.
            Bella da semana também faz promoções próprias
            periódicas. Será considerada quebra deste acordo
            utilizar-se de qualquer promoção, material promocional
            ou código promocional que não seja explicitamente
            autorizada por Bella da Semana para o Programa de Afiliados e nós
            nos reservamos o direito de reter ou desautorizar pagamentos por
            violações diante disto.
        </p>
    </li>
    <li>
        <p>
            Conformidade
            com o Acordo: o Bella da Semana tem o direito, de acordo com nossa
            própria discrição, de monitorar qualquer site
            Afiliado e, de tempos em tempos, determinar se o referido site está
            em conformidade com os termos deste acordo. Se, a qualquer tempo, o
            seu site afiliado não estiver em conformidade com os termos
            deste acordo, o Bella da Semana se reserva o direito de terminar sua
            participação no Programa, cancelando o contrato
            imediatamente. &nbsp;
        </p>
    </li>
</ul>
<p>
    <u><b>5.
        Propaganda Predatória</b>
    </u>
</p>
<p><a name="_GoBack"></a>
    Propaganda
    predatória é definida como qualquer método que
    crie ou sobreponha links ou banners em sites, janelas de spawns ou
    qualquer método inventado para gerar tráfego de um site
    sem a permissão expressa e por escrito do dono do referido
    site.
</p>
<p>
    Bella
    da semana concorda em não usar métodos de propaganda
    predatória desenhados para gerar tráfego que não
    tenham sido contratados para a promoção online de
    nossos produtos, serviços e Programa de afiliados.
</p>
<p>
    Os
    Afiliados concordam em não usar qualquer método de
    propaganda predatória na promoção de produtos
    Bella da Semana ou de seu Programa de Afiliados.
</p>
<p>
    Exemplos
    incluem, mas não se limitam as, keyword parsing browser
    plug-ins como TOText e Surf+, tecnologia de substituição
    de banner como Gator e tecnologia de browser spawning que não
    seja dependente do site.
</p>
<p>
    Participação
    em programas de propaganda predatória causarão o
    imediato desligamento do afiliado de nosso Programa e quaisquer
    comissões não pagas serão retidas,
    desautorizadas e/ou extornadas.
</p>
<p>
    <u><b>6.
        Colocação em Mecanismos de Busca</b>
    </u>
</p>
<p>
    Bella
    da Semana reconhece a necessidade de Afiliados em promover o Programa
    de Afiliados através de mecanismos de busca. Contudo, Bella da
    Semana se reserva o direito exclusivo de divulgação de
    nossas marcas em qualquer pay-for-placement e em toda e qualquer
    mecanismo de busca. As marcas incluem Bella Club, bellaclub.com,
    bellaclub.co.uk, Bella da Semana, belladasemana.com.br,
    belladasemana.com.com.pt, Bella Entretenimento, Bella Entertainment e
    qualquer outra variação de nossos nomes. Além
    disso, você não pode alegar ser o próprio Bella
    da Semana ou seu representante em qualquer mecanismo de busca,
    pay-for placement ou não. Violações serão
    causa para a terminação imediata do Acordo de Afiliado
    e quaisquer comissões não pagas serão retidas,
    desautorizadas e/ou estornadas.&nbsp; &nbsp;
</p>
<p>
    <u><b>7.
        Relação Corporativa</b>
    </u>
</p>
<p>
    Você
    concorda que sua relação de Afiliado com Bella da
    Semana não será utilizada como uma relação
    corporativa de qualquer tipo. A qualquer tempo, sua relação
    conosco será a de Afiliado como se é comumente definido
    pelo mercado. Se, a qualquer tempo, o Bella da Semana descobrir que
    você vem usando sua relação de afiliado para
    qualquer outro propósito que não o de afiliado, sua
    relação conosco será imediatamente terminada e
    as comissões obtidas através destas transações
    serão imediatamente retidas, desautorizadas ou estornadas. &nbsp;&nbsp;
</p>
<p>
    <u><b>8.
        Determinação de Comissão</b>
    </u>
</p>
<p>
    O
    preço da assinatura ao Bella da Semana variará de
    acordo com o número de meses escolhido pelo cliente. Apenas
    assinaturas confirmadas e para as quais nós tenhamos recolhido
    os pagamentos darão direito a comissão. 
</p>
<p>
    Sujeitas
    à Sessão 9(b) deste, taxas de Comissão serão
    de (i) cinquenta por cento (50%) por assinatura de usuários de
    seu site que acessem belladasemana.com utilizando o link provido por
    Bella da Semana, durante o primeiro ano de permanência do
    usuário no site, excluídos os montantes recolhidos por
    nós por taxas, impostos e cobranças similares,
    montantes devidos de fraude em cartão de crédito e mau
    débito e créditos por pagamentos suspensos. Comissões
    serão suspensas ou estornadas em caso de fraude de cartão
    de crédito, qualquer outro tipo de fraude, mau débito,
    crédito por pagamento suspenso ou violação deste
    Acordo. &nbsp;&nbsp;
</p>
<p>
    <u><b>9.
        Pagamento de Comissões</b>
    </u>
</p>
<p>
    Você
    receberá comissões baseado no número de
    assinaturas recebido por nós provenientes de seu site da forma
    a seguir:<br>50%
    do valor por assinaturas contratadas por seus usuários
    (descontadas as taxas citadas na cláusula 8) através de
    link fornecido por Bella da Semana, durante o primeiro ano de
    permanência do usuário no site. Os pagamentos são
    efetuados até o 15<sup>o</sup>
    dia do mês subsequente ao mês sendo pago, via Pagseguro.
</p>
<ol type="a">
    <li>
        <p>
            Sujeito
            à cláusula (b) abaixo, baseado no número de
            assinaturas recebidas por nós em conexão com os
            produtos comprados por seus usuários através de link
            provido por Bella da Semana, nós mandaremos a comissão
            correspondente, deduzidas de quaisquer taxas exigidas por lei.
            Diferentemente de outros Programas, você receberá as
            comissões aplicáveis de todas as novas assinaturas
            provenientes do link colocado em seu site fornecido por Bella da
            Semana pelo primeiro ano de permanência do usuário.
        </p>
    </li>
</ol>
<ol type="a" start="2">
    <li>
        <p>
            Se
            durante o primeiro mês de vigência deste acordo ou
            durante qualquer mês subsequente ao pagamento de comissões
            a você, suas comissões não excedam o montante de
            R$ 100,00 (Cem Reais) então você não receberá
            as referidas comissões durante o referido mês. Assim,
            você receberá comissões ao final do mês
            durante o qual suas comissões agregadas nos sucessivos
            períodos excedam o valor de R$ 100,00 (Cem Reais).
        </p>
    </li>
</ol>
<p>
    <u><b>10.
        Suas responsabilidades</b>
    </u>
</p>
<p>
    Você
    é responsável por assegurar que as descrições
    e artigos em seu site estejam de acordo com as leis internacionais de
    direitos autorais e outras leis. Você deve ter permissão
    expressa para usar material de outrem (caso use) ou autorização
    expressa para utilizar qualquer tipo de material. O Bella da Semana
    não será solidariamente responsável por
    quaisquer violações desta natureza.
</p>
<p>
    <u><b>11.
        Políticas e Preços</b>
    </u>
</p>
<p>
    Clientes
    que assinem Bella da Semana através do Programa de Afiliados
    Bella da Semana serão clientes Bella Entretenimento como
    qualquer outro. Conseqüentemente, todas as regras, políticas
    e procedimentos operacionais referentes a pedidos do consumidor,
    serviços ao consumidor ou vendas se aplicam igualmente a todos
    clientes. Nós podemos modificar nossas políticas e
    procedimentos operacionais a qualquer tempo, de acordo com nossa
    discrição. Por exemplo, nós determinaremos os
    preços dos produtos Bella da Semana de acordo com nossa
    própria política de preços e estes podem variar
    de tempos e tempos. Por esta razão, você não deve
    incluir informações sobre preço regularmente,
    exceto em casos específicos - e temporários - de
    promoção.
</p>
<p>
    <u><b>12.
        Publicidade</b>
    </u>
</p>
<p>
    Você
    não deve criar, publicar, distribuir ou permitir qualquer
    material escrito que faça referência a Bella da Semana
    sem antes submeter tal material a aprovação por
    consentimento escrito de Bella da Semana, que nós podemos ou
    não fornecer, de acordo com nossos próprios critérios.
</p>
<p>
    <u><b>13.
        Direito de Propriedade Intelectual</b>
    </u>
</p>
<p>
    Licenças
    e usos de Logos e Marcas Bella:<br>Nós garantimos a você
    o direito não-exclusivo, intransferível e revogável
    a (i) acessar o site Bella da Semana através dos links de
    acordo com os termos deste Acordo e (ii) unicamente em relação
    a estes links e sob as condições estabelecidas aqui,
    usar nossas logos, nomes comerciais, marcas e qualquer outra material
    identificador que se relacione a Bella da Semana (aqui denominado
    coletivamente como “material licenciado”), para o
    exclusivo propósito de venda de produtos Bella da Semana em
    seu site. Você não pode alterar, modificar ou mudar os
    materiais licenciados de maneira alguma sem o consentimento prévio
    e expresso de Bella. O uso de tais materiais somente é
    permitido enquanto durar sua permanência no Programa de
    Afiliados Bella da Semana.
</p>
<ol type="a">
    <li>
        <p>
            Você
            não deverá fazer uso específico de qualquer
            material licenciado para outros propósitos que não a
            venda de produtos Bella da Semana em seu site, sem antes submeter
            uma amostra para aprovação e obter prévio e
            escrito consentimento. Nós nos reservamos o direito sobre
            referidos materiais e quaisquer outros direitos de propriedade.
            Reservamo-nos também o direito de revogar sua licença
            a qualquer tempo.
        </p>
    </li>
    <li>
        <p>
            Você
            nos assegura o direito não-exclusivo de utilizar seus nomes,
            títulos e logos para fins promocionais, de marketing,
            promoção ou publicidade de qualquer forma –
            sabendo-se que o Bella da Semana não tem a obrigação
            de fazê-lo sob qualquer circunstância. O direito de
            licença expira juntamente com a terminação
            deste Acordo.
        </p>
    </li>
    <li>
        <p>
            Você
            também concorda e entende plenamente as seguintes regras para
            uso das marcas Bella:&nbsp;&nbsp;
        </p>
        <ol type="i">
            <li>
                <p>
                    Você
                    pode usar as marcas apenas com autorização de Bella
                    da Semana.
                </p>
            </li>
            <li>
                <p>
                    Você
                    não pode alterar as marcas de maneira alguma. Por exemplo,
                    você não pode modificar a proporção, cor
                    ou fonte das marcas e logos.
                </p>
            </li>
            <li>
                <p>
                    Você
                    não pode exibir as marcas de maneira que sugira patrocínio,
                    endosso ou qualquer tipo de envolvimento de Bella da Semana que não
                    seja parte do Programa de afiliados.
                </p>
            </li>
            <li>
                <p>
                    Você
                    não é autorizado a utilizar as Marcas para divulgar
                    Bella da Semana, qualquer de seus produtos ou serviços e
                    ainda outros afiliados de modo pejorativo ou que os diminua de
                    qualquer maneira, prejudicando a imagem de qualquer dos
                    supracitados.
                </p>
            </li>
            <li>
                <p>
                    As
                    marcas devem aparecer sós, com espaço razoável
                    (pelo menos a altura da Marca) entre elementos gráficos e
                    textuais.
                </p>
            </li>
            <li>
                <p>
                    Você
                    reconhece que todos os direitos sobre as Marcas são de
                    propriedade exclusiva de Bella e qualquer benefício delas
                    proveniente será de Bella da Semana.&nbsp;&nbsp;&nbsp;
                </p>
            </li>
        </ol>
    </li>
</ol>
<p>
    <u><b>14.
        Obrigações Referentes a Seu Site</b>
    </u>
</p>
<p>
    Você
    será o único responsável pelo desenvolvimento,
    operação e manutenção de seu site e por
    todo e qualquer material que apareça ali. Tais
    responsabilidades incluem, mas não se limitam a, operações
    técnicas em seu site e todo o equipamento relacionado; criação
    de gifs, descrições e referências em seu site que
    estejam ligadas ao nosso; correção e propriedade de
    materiais postados em seu site – incluindo, mas não
    limitado aos materiais relacionados direta ou indiretamente com Bella
    da Semana); assegurar que materiais postados em seu site não
    violem ou infrinjam nenhum direito de terceiro e não seja de
    maneira alguma ilegal.
</p>
<p>
    A
    Bella da Semana se isenta de toda e qualquer responsabilidade a
    respeito de tais ações. Você garantirá a
    proteção de Bella contra quaisquer tipos de ações
    de danos ou indenizatórias – (incluindo, mas não
    se limitando a custos advocatícios) relacionados ao
    desenvolvimento, operação, manutenção e
    conteúdos de seu site.&nbsp;
</p>
<p>
    <u><b>15.
        Termo do Acordo</b>
    </u>
</p>
<p>
    O
    termo deste Acordo terá início mediante o aceite da sua
    participação no Programa de Afiliados por Bella da
    Semana e findará quando qualquer uma das partes manifeste sua
    vontade em fazê-lo. Tanto o Afiliado quanto o Bella da Semana
    podem terminar o Acordo a qualquer tempo, independente de causa ou
    justificativa, a partir do momento que notifique a outra parte por
    escrito. O afiliado só tem direito às comissões
    de vendas durante o termo deste Acordo. Comissões sobre vendas
    que ocorram durante o processo de rescisão apenas serão
    pagas se os pedidos não forem cancelados. Nós nos
    reservamos o direito de reter o último pagamento por um tempo
    razoável para garantir que o montante correto seja pago de
    acordo com os termos e condições deste Acordo.
</p>
<p>
    <u><b>16.
        Alterações</b>
    </u>
</p>
<p>
    É
    permitido a Bella da Semana que modifique quaisquer dos termos e
    condições contidos neste Acordo, a qualquer tempo, sem
    justificação. Você será notificado por
    e-mail e uma nota sobre a mudança será colocada em
    nosso site. Modificações podem incluir, mas não
    estão limitadas à mudanças no escopo de
    disponibilidade de comissões, dia de recebimento de comissões,
    procedimentos de pagamento e regras sobre o Programa de afiliados de
    Bella da Semana. Se qualquer modificação lhe for
    inaceitável, seu único e qualquer recurso é
    terminar o presente Acordo. Sua participação continuada
    no Programa após postarmos avisos de modificação
    constitui sua aceitação tácita quanto às
    referidas mudanças.
</p>
<p>
    <u><b>17.
        Relação entre as Partes</b>
    </u>
</p>
<p>
    O
    afiliado e Bella da Semana são partes independentes e nada
    neste acordo cria nenhum tipo de parceria, joint venture, agência,
    franquia, representação de vendas ou vínculo
    empregatício entre as partes. O afiliado não tem
    autoridade para fazer ou aceitar oferta alguma em nome de Bella da
    Semana.
</p>
<p>
    <u><b>18.
        Representação e Garantias</b>
    </u>
</p>
<p>
    Você
    representa e garante o seguinte:
</p>
<ul>
    <li>
        <p>
            Este
            Acordo foi devida e validamente executado e entregue por você
            e constitui sua obrigação legal e válida de
            acordo com estes termos;
        </p>
    </li>
    <li>
        <p>
            A
            execução deste Acordo pela parte do Afiliado e a
            consumação das transações discutidas
            neste, independente de notificação ou tempo entrem em
            conflito com (i) qualquer legislação ou regulamentação
            a que o Afiliado esteja sujeito, (ii) qualquer ordem, sentença
            ou decreto aplicável ao Afiliado ou a seus bens ou
            propriedades, (iii) qualquer legislação ou certificado
            de incorporação ou (iv) qualquer acordo ou outro
            instrumento a que esteja vinculado o Afiliado ou qualquer um de seus
            bens.
        </p>
    </li>
    <li>
        <p>
            Você
            é o único e exclusivo detentor de suas marcas e tem o
            direito de nos conceder a licença de uso como estabelecida
            neste Acordo e tal licença não&nbsp; (i) quebra,
            conflita com ou constitui falta perante qualquer outro acordo ou
            instrumento aplicável a você, seus bens ou propriedades
            ou (ii) infringe qualquer marca, nome, serviço, direito ou
            outra propriedade de qualquer outra pessoa, empresa ou entidade.&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;
        </p>
    </li>
</ul>
<p>
    <u><b>19.
        Confidencialidade.</b>
    </u>
</p>
<p>
    Exceto
    pelo já mencionado neste Acordo ou pelo consentimento escrito
    da outra parte neste envolvida, cada uma das partes concorda que toda
    a informação, incluindo os termos do acordo,
    informações sobre o negócio ou financeira, lista
    de clientes, informações sobre preços ou vendas
    de qualquer uma das partes devem permanecer estritamente
    confidenciais e sigilosas e não devem ser utilizadas, direta
    ou indiretamente, por nenhuma das partes para propósitos de
    seus negócios ou qualquer outro propósito exceto e
    somente até a extensão em que a informação
    seja de conhecimento geral ou disponível para o público
    através de uma fonte ou fontes que não a outra parte ou
    seus afiliados.
</p>
<p>
    <u><b>20.
        Limitação de Responsabilidade</b>
    </u>
</p>
<p>
    O
    BELLA DA SEMANA NÃO SERÁ RESPONSABILIZADO POR DANOS
    INDIRETOS, ESPECIAIS OU CONSEQÜENCIAIS OU QUALQUER PERDA OU
    DIMINUIÇÃO DE RECEITA, LUCROS OU DADOS EM CONEXÃO
    COM ESTE ACORDO OU O PROGRAMA DE AFILIADOS DO BELLA, AINDA QUE
    SEJAMOS AVISADOS DA POSSIBILIDADE DE DANO. ADEMAIS, A
    RESPONSABILIDADE AGREGADA RELACIONADA A ESTE ACORDO E O PROGRAMA DE
    AFILIADOS DO BELLA NÃO EXCEDERÁ O MONTANTE DE COMISSÕES
    PAGAS AO AFILIADO AO LONGO DO TERMO.
</p>
<p>
    <u><b>21.
        Investigação Independente</b>
    </u>
</p>
<p>
    O
    AFILIADO RECONHECE TER LIDO TODO O CONTEÚDO DESTE ACORDO E
    CONCORDA COM TODOS OS SEUS TERMOS E CONDIÇÕES. O
    AFILIADO AVALIOU INDEPENDENTEMENTE O DESEJO DE PARTICIPAR DO PROGRAMA
    DE AFILIADOS DO BELLA DA SEMANA E NÃO DEPENDE DE NENHUMA
    REPRESENTAÇÃO, GARANTIA OU DECLARAÇÃO
    EXTERNA A ESTE ACORDO. ESTE ACORDO COMPREENDE TODO O ACORDO ENTRE E
    ENTENDIMENTO ENTRE AS PARTES RELACIONADAS AO ASSUNTO AQUI DISCORRIDO
    E REÚNE TODOS OS ACORDOS, DISCUSSÕES E ENTENDIMENTOS
    PRÉVIOS A ESTE.
</p>
<p>
    <u><b>22.
        Foro</b>
    </u>
</p>
<p>
    Este
    Acordo está submetido à legislação
    brasileira e, mais especificamente, às leis do Estado de Santa
    Catarina, sem quaisquer referências a outras leis ou foro.
    Qualquer ação relacionada a este Acordo deve ser
    trazida às cortes locais de Florianópolis, Santa
    Catarina, e o afiliado consente a jurisdição de tais
    leis e cortes.
</p>
<p>
    <u><b>23.
        Notificações</b>
    </u>
</p>
<p>
    Notificações
    são consideradas válidas quando enviadas de forma
    escrita para endereço postal ou eletrônico preenchidos
    no formulário ou se colocados em nosso site. Notificações
    ao Bella da semana serão consideradas se endereçadas ao
    endereço postal R. Jerônimo Coelho, 383 – 506 –
    Centro – Florianópolis – SC – 88025-000, aos
    cuidados ou através da página de contato do site.
</p>
<p>
    <u><b>24.
        Resolução de Disputas</b>
    </u>
</p>
<p>
    As
    partes tentarão dirimir de boa fé através de
    negociações, quaisquer disputas ou controvérsias
    que emerjam deste Acordo. Caso a disputa não seja resolvida
    pelas cortes de justiça em Florianópolis, Santa
    Catarina.
</p>`,
    html: `No ar desde 2001, o Bella da Semana é um dos mais conhecidos e respeitados portais de
          fotografias sensuais da internet. É fácil ganhar dinheiro com o Bella! Oferecemos uma
          parceira sem custo, que garante a você comissões fixas. Nosso Programa de Afiliados
          funciona da seguinte forma:
          <br />

          <h3 class="terms-big">Cadastro</h3>

          Para dar início ao Programa de Afiliados Bella da Semana preencha a
          <a :href="/pt-br/programa-afiliados/subscribe"
            >ficha cadastral</a
          >
          em nosso site. Uma vez aprovada, você receberá um link automático que deverá ser
          adicionado ao seu site como banner ou em forma de link.
          <br />

          Sempre que um usuário entrar no Bella da Semana através do seu link, ele receberá um
          cookie permanente, que permitirá identificá-lo como um cliente vindo por indicação sua.
          <br />

          Quanto mais cliques você gerar, maiores as chances de um visitante tornar-se membro do
          Bella da Semana e de você ganhar comissões. A cada assinatura gerada através do link
          postado em seu site, você recebe uma comissão de 50% sobre o valor da assinatura.
          <br />

          <h3 class="terms-big">Pagamento</h3>
          Os pagamentos são cumulativos e repassados a você no dia 07 de cada mês via PagSeguro ou
          PayPal. Caso as comissões resultem um em montante inferior a R$ 100,00 o valor acumula até
          que o valor seja atingido, para então ser repassado.
          <br />

          <h3 class="terms-big">Controle</h3>
          Para que você tenha total controle e possa acompanhar a contabilização passo-a-passo, você
          terá acesso à área reservada aos
          <a href="{{ route('partners.login', [App::getLocale()]) }}" rel="nofollow">parceiros</a>
          do Bella da Semana, na qual é possível verificar toda a movimentação gerada pelo link em
          seu site, como relatórios de vendas, quantos cliques seu site gerou e o número de
          assinaturas concretizadas.
          <br />

          <h3 class="terms-big">Dúvidas</h3>
          Leia nosso FAQ para mais informações ou fale conosco através do
          <a :href="/pt-br/programa-afiliados/subscribe">formulário de contato</a>.`
  },
  ingles: {
    title: 'Affiliate Program',
    subTitle: "Check out the answers to our partners' most frequently asked questions below:",
    list: [
      {
        title: 'What is an Affiliate?',
        subtitle: `Our Affiliate Program allows you to place a link from your website to ours. Every time a user clicks on the link and subscribes to Bella Club, you receive a commission of 50% of the subscription and renewal value, for 12 months. It's very easy to obtain fast and free earnings, increasing the profit of your website.`
      },
      {
        title: 'Why should I sign up?',
        subtitle: `We allow you to have additional income for your website with minimal effort. We take care of all the 'complications': processing subscriptions, contracts and customer service. All you have to do is place our banner on your website - as you probably already do - creating a new source of income.`
      },
      {
        title: 'How much is my commission?',
        subtitle: `We have the best commission on the market! As a Bella da Semana partner, you receive 50% of the value of each new subscription generated by your website, which can be for one, three, six or 12 months. In addition, unlike other Affiliate Programs, you are paid monthly.`
      },
      {
        title: 'How can I have control over how much commission I am earning?',
        subtitle: `We have developed a system to guarantee you all possible security. Through a special website located at www.belladasemana.com.br/afiliado you can track the performance of your link, including: impressions, clicks, conversion rate, best-selling products, subscriptions and commissions. Everything updated daily!`
      },
      {
        title: 'My website is outside Brazil, can I still participate?',
        subtitle: `Bella da Semana is an international website, as is our Affiliate Program. We are perfectly prepared for foreign affiliates.`
      },
      {
        title: 'How is the after-sales service handled?',
        subtitle: `All subscriptions are processed by Bella da Semana and we take care of all the after-sales and any customer service issues - you don't need to worry about a thing.`
      }
    ],
    sunscribeTitle:
      'To start the Bella Club Affiliate Program, fill out the registration form below',
    subscribeNameEnterprise: 'Company Name',
    subscribeName: 'Contact Person',
    subscribeNumber: 'Phone',
    subscribeMail: 'Email for Login/Contact',
    subscribePassword: 'Password',
    subscribePasswordConfirm: 'Confirm Password',
    subscribeUrl: 'Website URL',
    subscribeButton: 'Submit',
    failSend: 'Failed to submit form!',
    msgClose: 'Close',
    msgTitle1: 'Error',
    msgTitle2: 'Warning',
    generM: 'Sir',
    generF: 'Madam',
    titleTermsUse: 'TERMS AND CONDITIONS',
    aceitlabel: 'I accept the Terms',
    imgHome: 'https://api.belladasemana.com.br/storage/en/partner-fluxo-en.png',
    imgFooter: 'https://api.belladasemana.com.br/storage/en/afiliate-bottom-opcs.png',
    msgSuccess:
      'Your request to join the Affiliate Program is under review.<br>We will contact you shortly. Please wait!',
    terms: `<p>
    <b>Affiliate
    Program - Terms and conditions</b></p>
    <p>
    At no time may
    you claim Bella Club products or brands as your own or rename Bells
    Club products in anyway. 
    </p>
    <p>
    Use of
    unsolicited email/spam to promote the Bella Club Affiliate Program is
    strictly forbidden. If you use spam to promote the service you will
    be notified that your account has been terminated and all pending
    commissions will be unearned, disallowed and/or charged back. 
    </p>
    <p>
    All Affiliate
    Sites shall display such graphic and/or textual images prominently in
    relevant sections of their site. All Links may be modified and/or
    expanded from time to time throughout the term of this Agreement
    pursuant to the mutual agreement of the parties hereto. Each Link
    connecting users of your site to the pertinent area of our site will
    in no way alter the look, feel, or functionality of our site. 
    </p>
    <p>
    We will be
    responsible for providing Links from your site to our site. We will
    be solely responsible for processing every subscription following a
    special Link from your site, for tracking the volume and amount of
    subscriptions generated by your site, and for providing information
    to Affiliate Sites regarding subscription statistics. We will be
    responsible for the whole subscription process, including payment
    processing, cancellations, and related customer service.</p>
    <p>
    <u><b>1.
    Custom Content.</b></u></p>
    <p>
    "Custom
    Content" means the textual, pictorial and/or graphic content
    created by or on behalf of the Affiliate representing, describing or
    referring to Bella Club’s products and authorized in writing by
    Bella Club. 
    </p>
    <p>
    Prior to
    Affiliate using any Custom Content, you shall provide Bella Club with
    samples in an electronic format and submit a written request for
    approval of such use to Bella Club. Bella Club may withhold its
    consent in its sole discretion for any reason. If Bella Club does not
    approve the Custom Content in writing within ten (10) business days
    of receipt of such request, Bella Club shall be deemed to have
    rejected the request. Affiliate may submit revised requests for
    approval of any use to which Bella Club objected. Bella Club may
    withdraw its approval at any time without cause.</p>
    <p>
    You agree not
    to use the Custom Content of other Bella Club Affiliates or other
    partners without the written approval of Bella Club and that
    Affiliate or other Partner.</p>
    <p>
    <u><b>2. Other
    Opportunities and Responsibilities of Affiliate Sites.</b></u>

    </p>
    <ul>
    <li><p>
    Prominent
    Placement of Links. If you qualify and agree to participate as an
    Affiliate Site, you shall display Links prominently throughout your
    site as you see fit and with our consent. 
    </p>
    </li><li><p>
    Contests and
    Promotions: Bella Club will, from time to time, provide all of our
    affiliates with promotions, offered at our discretion, to offer to
    your members/visitors. We will provide you with adequate notice so
    that you may make any and all appropriate changes to your website.
    Bella Club also runs periodic promotions of its own. It will be
    considered a breach of this agreement to utilize any promotion,
    promotion code or other promotional opportunity as an affiliate link
    that is not specifically authorized by Bella Club for the affiliate
    program and we reserve the right to withhold or disallow payment for
    violations under this section. In addition, you will be entitled to
    earn commissions as set forth below. 
    </p>
    </li><li><p>
    Compliance
    with the Agreement. We have the right in our sole discretion to
    monitor your site at any time and from time to time to determine if
    you are in compliance with the terms of this Agreement. If at any
    time you are not in compliance with the terms of this Agreement, we
    reserve the right to terminate this Affiliate Agreement immediately.</p>
    </li></ul>
    <p>
    <u><b>3.
    Predatory Advertising.</b></u></p>
    <p>
    &nbsp;Predatory
    advertising is defined as any method that creates or overlays links
    or banners on web sites, spawns browser windows, or any method
    invented to generate traffic from a web site without that web site
    owner\'s expressed, written permission. 
    </p>
    <p>
    Bella Club
    agrees not to use predatory advertising methods designed to generate
    traffic from sites they have not contracted with for the online
    promotion of our products, services and affiliate program. 
    </p>
    <p>
    Affiliate
    agrees not to use any predatory advertising methods in the promotion
    of Bella Club products or affiliate program. 
    </p>
    <p>
    Examples
    include, but are not limited to, keyword parsing browser plug-ins
    such as TopText and Surf+, banner replacement technology such as
    Gator, and browser spawning technology that is not web site
    dependent. 
    </p>
    <p>
    Participation
    in predatory advertising programs will be cause for affiliate\'s
    immediate termination and any unpaid commissions will be unearned,
    disallowed and/or charged back.</p>
    <p>
    <u><b>4.
    Search Engine Placement.</b></u></p>
    <p>
    Bella Club
    recognizes the need for affiliates to promote the Bella Club
    Affiliate Program through search engine placement. However, Bella
    Club reserves exclusive rights as to the advertising of our
    trademarked company name within all pay-for-placement and all other
    search engines. These names include: Bella Club, bellaclub.com Bella
    da Semana, Bella Entertainment, etc and any variation of our
    trademarked name. Additionally, you may not claim to be Bella Club in
    any pay-for-placement or other search engines. Violations will be
    cause for affiliate\'s immediate termination and any unpaid
    commissions will be unearned, disallowed and/or charged back.</p>
    <p>
    <u><b>5.
    Corporate/Client Account.</b></u></p>
    <p>
    You agree that
    your affiliate relationship with Bella Club will not be utilized as a
    corporate account or corporate relationship (defined for these
    purposes as the purchasing of multiple gifts for customer acquisition
    or retention, employee incentives or corporate gifting) of any kind
    with Bella Club. At all times, your relationship with us will be as
    an affiliate as it is commonly defined in the industry. If, at any
    time, we discover that you are using your affiliate relationship with
    us for any reason other than that of an affiliate, your relationship
    with us will be immediately terminated and any commissions earned as
    a result of the transaction or transactions that gave rise to said
    termination shall immediately be unearned, disallowed and/or charged
    back. 
    </p>
    <p>
    <u><b>6.
    Commission Determination.</b></u></p>
    <p>
    The
    subscription to Bella Club price will vary according to the number of
    months client signs up. Only subscriptions that are confirmed and for
    which we have received payment will qualify for a commission.</p>
    <p>
    Subject to
    Section 9(b) hereof, Commission rates will be (i) fifty percent (50%)
    for subscription by users of your site who access bellaclub.com and
        sign up utilizing a link to bellaclub.com, during the first year of
    permanence of the paying customer in the website, independently from
    the number of months client subscribes for, excluding amounts
    collected by us for sales taxes, duties, and similar charges, amounts
    due to credit card fraud and bad debt, and credits for sustained
    payments. Commissions paid will be charged back as a result of
    customer credit card fraud, any other form of fraud (or the
    appearance thereof), bad debt, credits for sustained payment or
    violation of this Agreement.</p>
    <p>
    <u><b>7.
    Commission Payment.</b></u></p>
    <p>
    You will
    receive commissions based on Number of Subscriptions received by us
    from your website as follows: 
    </p>
    <p>
    Fifty percent
    (50%) of the amount of subscriptions purchased by your users through
    a Link to our Home Page or individual product pages (deducted the
    taxes mentioned in clause 6), for the first years of permanence of
    the paying customer in the website. Payments occur up to the 15<sup>th</sup>
    of every month, always at least a month after subscription, via
    Paypal. 
    </p>
    <ol type="a">
    <li><p>
    Subject to
    clause (b) below, based on Number of Subscriptions received by us in
    connection with sales of Bella Club Products purchased by your users
    through a Link to our site, we will send you the commission fee,
    less any taxes required to be withheld under applicable law. Unlike
    other programs, you will receive the applicable commission from all
    new subscriptions by users that come to bellaclub.com by means of
    the Link from your site, during the first year of permanence of the
    paying customer in the website.</p>
    </li><li><p>
    If during the
    first month of the term of this Agreement, or during any month
    following the payment of commissions to you, your commissions earned
    do not exceed one hundred dollars (US$ 100.00), then you shall not
    be entitled to receive any commissions during the applicable month.
    Thereafter, you will be paid commissions at the end of the month
    during which your aggregate commissions earned during such
    successive period exceed one hundred dollars (US$ 100.00). At such
    time, you will be paid all commissions you would have otherwise been
    entitled to had your commissions exceeded twenty dollars (US$
    100.00).</p>
    </li></ol>
    <p>
    <u><b>8.
    Reports of Sales.</b></u></p>
    <p>
    You will be
    given a password and have the ability to enter a password-protected
    site to receive your subscription statistics on a daily basis.</p>
    <p>
    <u><b>9. Your
    Responsibilities.</b></u></p>
    <p>
    You are solely
    responsible for ensuring that descriptions and articles on your site
    comply with applicable copyright and other laws. You must have
    express permission to use another party\'s copyrighted or other
    proprietary material. We are not responsible for violations.</p>
    <p>
    <u><b>10.
    Policies and Pricing.</b></u></p>
    <p>
    Customers who
    subscribe to Bella Club through the Bella Club Affiliate Program will
    be deemed to be customers of Bella Entertainment. Accordingly, all of
    our rules, policies, and operating procedures concerning customer
    orders, customer service, and sales will apply to those customers. We
    may change our policies and operating procedures at any time and at
    our sole discretion. For example, we will determine the prices to be
    charged for Bella Club Products in accordance with our own pricing
    policies. Bella Club prices and availability may vary from time to
    time. Because price changes may affect products that you already have
    listed on your site, you should not include price information in your
    Product descriptions.</p>
    <p>
    <u><b>11.
    Publicity.</b></u></p>
    <p>
    You shall not
    create, publish, distribute, or permit any written material that
    makes reference to us without first submitting such material to us
    and receiving our written consent, which we may withhold in our sole
    discretion.</p>
    <p>
    <u><b>12.
    Intellectual Property Rights.</b></u></p>
    <p>
    Licenses and
    Use of Bella Logos and Trademarks: 
    </p>
    <p>
    WE GRANT YOU A
    NON-EXCLUSIVE, NON-TRANSFERABLE, REVOCABLE RIGHT TO (i) ACCESS OUR
    SITE THROUGH THE LINKS IN ACCORDANCE WITH THE TERMS OF THIS AGREEMENT
    AND (ii) SOLELY IN CONNECTION WITH SUCH LINKS AND UNDER THE
    CONDITIONS PROVIDED FOR HEREIN, TO USE OUR LOGOS, TRADE NAMES,
    TRADEMARKS, AND SIMILAR IDENTIFYING MATERIAL RELATING TO US
    (COLLECTIVELY, THE "LICENSED MATERIALS"), FOR THE SOLE
    PURPOSE OF SELLING BELLACLUB.COM PRODUCTS ON YOUR SITE FOR BELLA
    CLUB. YOU MAY NOT ALTER, MODIFY, OR CHANGE THE LICENSED MATERIALS IN
    ANY WAY WITHOUT OUR PRIOR WRITTEN PERMISSION. YOU ARE ONLY ENTITLED
    TO USE THE LICENSED MATERIALS WHILE YOU ARE A MEMBER IN GOOD STANDING
    OF THE BELLA CLUB AFFILIATE PROGRAM. 
    </p>
    <ol type="a">
    <li><p>
    You shall not
    make any specific use of any Licensed Materials for purposes other
    than selling bellaclub.com on your site, without first submitting a
    sample of such to us and obtaining the prior written consent, which
    shall not be unreasonably withheld. We reserve all of our rights in
    the Licensed Materials and of our other proprietary rights. We may
    revoke your license at any time, with or without notice. 
    </p>
    </li><li><p>
    You grant to
    us a non-exclusive license to utilize your names, titles, and logos
    as set forth on Exhibit A hereto, as the same may be amended from
    time to time, to advertise, market, promote, and publicize in any
    manner our rights hereunder; provided, however, that we shall not be
    required to so advertise, market, promote, or publicize. This
    license shall terminate upon the effective date of the expiration or
    termination of this Agreement. 
    </p>
    </li><li><p>
    You also
    agree to and understand the following guidelines for using Bella
    Trademarks: 
    </p>
    <ol type="i">
    <li><p>
    You may use
    the Trademarks solely for the purpose authorized by Bella.</p>
    </li><li><p>
    You may not
    alter the Trademarks in any manner. For example, you may not change
    the proportion, color, or font of the Trademarks. 
    </p>
    </li><li><p>
    You may not
    display the Trademarks in any manner that implies sponsorship,
    endorsement by Bella, outside of your involvement in the Affiliate
    program. 
    </p>
    </li><li><p>
    You may not
    use the Trademarks to disparage Bella Club or any of its
    affiliates, its products or services, or in any manner which, in
    Bella Club’s sole discretion, may diminish or otherwise
    damage Bella Club’s goodwill in the Trademarks. 
    </p>
    </li><li><p>
    The
    Trademarks must appear by themselves, with reasonable spacing (at
    least the height of the Trademarks) and other graphic or textual
    elements. 
    </p>
    </li><li><p>
    You
    acknowledge that all rights to the Trademarks are the exclusive
    property of Bella Club and all goodwill generated through your use
    of the Trademarks will inure to the benefit of Bella Club.</p>
    </li></ol>
    </li></ol>
    <p>
    Bella Club
    reserves the right in its sole discretion to modify these guidelines
    at any time. Bella Club reserves the right to take action against any
    use that does not conform to these guidelines.</p>
    <p>
    <u><b>13.
    Obligations Regarding Your Site.</b></u></p>
    <p>
    You will be
    solely responsible for the development, operation, and maintenance of
    your site and for all materials that appear on your site. Such
    responsibilities include, but are not limited to, the technical
    operation of your site and all related equipment; creating and
    posting gifts, descriptions, and references on your site and linking
    those descriptions to our site; the accuracy and propriety of
    materials posted on your site (including, but not limited to, all
    Bella Club-related materials); ensuring that materials posted on your
    site do not violate or infringe upon the rights of any third party
    and are not otherwise illegal. <br>We disclaim all liability for all
    such matters. Further, you will indemnify and hold us harmless from
    all claims, damages, and expenses (including, without limitation,
    attorneys\' fees) relating to the development, operation, maintenance,
    and contents of your site.</p>
    <p>
    <u><b>14. Term
    of the Agreement.</b></u></p>
    <p>
    The term of
    this Agreement will begin upon our acceptance of your Bella Club
    Affiliate Program application and will end when terminated by either
    party. Either the affiliate or Bella may terminate this Agreement at
    any time, with or without cause, by giving the other party written
    notice of termination. You are only eligible to earn commission fees
    on sales occurring during the term, and fees earned through the date
    of termination will remain payable only if the related bellaclub.com
    orders are not cancelled. We may withhold your final payment for a
    reasonable time to ensure that the correct amount is paid and your
    compliance with all the terms and conditions of this Agreement.</p>
    <p>
    <u><b>15.
    Modification.</b></u></p>
    <p>
    We may modify
    any of the terms and conditions contained in this Agreement, at any
    time in our sole discretion. You will be notified by email and a
    change notice will be posted on our site. Modifications may include,
    but are not limited to, changes in the scope of available commission
    fees, commission schedules, payment procedures, and Bella Club
    Affiliate program rules. If any modification is unacceptable to you,
    your sole and exclusive recourse is to terminate this agreement. Your
    continued participation in the Bella Club Affiliate Program following
    our posting of a change notice or new agreement on our site will
    constitute binding acceptance of the change. 
    </p>
    <p>
    <u><b>16.
    Relationship of Parties.</b></u></p>
    <p>
    You and the
    Company are independent contractors, and nothing in this Agreement
    will create any partnership, joint venture, agency, franchise, sales
    representative, or employment relationship between the parties. You
    have no authority to make or accept any offers or representations on
    our behalf.</p>
    <p>
    <u><b>17.
    Representations and Warranties.</b></u></p>
    <p>
    You hereby
    represent and warrant to us as follows: 
    </p>
    <ol type="a">
    <li><p>
    This
    Agreement has been duly and validly executed and delivered by you
    and constitutes your legal, valid, and binding obligation,
    enforceable in accordance with its terms. 
    </p>
    </li><li><p>
    The
    execution, delivery, and performance by you of this Agreement and
    the consummation by you of the transactions discussed herein will
    not, with or without the giving of notice, the lapse of time, or
    both, conflict with or violate (i) any provision of law, rule, or
    regulation to which you are subject, (ii) any order, judgment, or
    decree applicable to you or binding upon your assets or properties,
    (iii) any provision of your by-laws or certificate of incorporation,
    or (iv) any agreement or other instrument applicable to you or
    binding upon you or your assets. 
    </p>
    </li><li><p>
    You are the
    sole and exclusive owner of your Trademarks and have the right and
    power to grant to us the license to use your trademarks in the
    manner contemplated herein, and such grant does not (i) breach,
    conflict with, or constitute a default under any agreement or other
    instrument applicable to you or binding upon your assets or
    properties, or (ii) infringe upon any trademark, trade name, service
    mark, copyright, or other proprietary right of any other person or
    entity. 
    </p>
    </li><li><p>
    No consent,
    approval, or authorization of, or exemption by, or filing with, any
    governmental authority or any third party is required to be obtained
    or made by you in connection with the execution, delivery, and
    performance of this Agreement or the taking by you of any other
    action discussed herein. 
    </p>
    </li><li><p>
    There is no
    pending or, to the best of your knowledge, threatened claim, action,
    or proceeding against you, or any affiliate of yours, with respect
    to the execution, delivery or consummation of this Agreement, or
    with respect to your trademarks, and, to the best of your knowledge,
    there is no basis for any such claim, action, or proceeding.</p>
    </li></ol>
    <p>
    <u><b>18.
    Confidentiality.</b></u></p>
    <p>
    Except as
    otherwise provided in this Agreement or with the written consent of
    the other party hereto, each of the parties hereto agrees that all
    information including, without limitation, the terms of this
    Agreement, business and financial information, customer and vendor
    lists, and pricing and sales information, concerning us or you,
    respectively, or any of our affiliates provided by or on behalf of
    any of them shall remain strictly confidential and secret and shall
    not be utilized, directly or indirectly, by such party for its own
    business purposes or for any other purpose except and solely to the
    extent that any such information is generally known or available to
    the public through a source or sources other than such party hereto
    or its affiliates.</p>
    <p>
    <u><b>19.
    Limitation of Liability.</b></u></p>
    <p>
    WE WILL NOT BE
    LIABLE FOR INDIRECT, SPECIAL, OR CONSEQUENTIAL DAMAGES, OR ANY LOSS
    OF REVENUE, PROFITS, OR DATA, ARISING IN CONNECTION WITH THIS
    AGREEMENT OR BELLA’S AFFILIATE PROGRAM, EVEN IF WE HAVE BEEN
    ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. FURTHER, OUR AGGREGATE
    LIABILITY ARISING WITH RESPECT TO THIS AGREEMENT AND BELLA’S
    AFFILIATE PROGRAM WILL NOT EXCEED THE TOTAL COMMISSION FEES PAID TO
    YOU UNDER THIS AGREEMENT.</p>
    <p>
    <u><b>20.
    Indemnification.</b></u></p>
    <p>
    You hereby
    agree to indemnify and hold harmless Bella Club, and its subsidiaries
    and affiliates, and their directors, officers, employees, agents,
    shareholders, partners, members, and other owners, against any and
    all claims, actions, demands, liabilities, losses, damages,
    judgments, settlements, costs, and expenses (including reasonable
        attorneys\' fees) (any or all of the foregoing hereinafter referred to
            as "Losses") insofar as such Losses (or actions in respect
    thereof) arise out of or are based on (i) any claim that our use of
    the Affiliate Trademarks infringes on any trademark, trade name,
    service mark, copyright, license, intellectual property, or other
    proprietary right of any third party, (ii) any misrepresentation or
    warranty breach or breach of a covenant or agreement made by you
    herein, or (iii) any claim related to your site, including, without
    limitation, content therein. You agree to promptly notify Bella Club
    of any such claim for Losses and agree to fully cooperate with Bella
    Club in defense thereof.</p>
    <p>
    <u><b>21.
    Independent Investigation and Entire Agreement</b></u>.</p>
    <p>
    YOU
    ACKNOWLEDGE THAT YOU HAVE READ THIS AGREEMENT AND AGREE TO ALL OF ITS
    TERMS AND CONDITIONS. YOU HAVE INDEPENDENTLY EVALUATED THE
    DESIRABILITY OF PARTICIPATING IN THE BELLA CLUB AFFILIATE PROGRAM AND
    ARE NOT RELYING ON ANY REPRESENTATION, GUARANTEE, OR STATEMENT OTHER
    THAN AS SET FORTH IN THIS AGREEMENT. THIS AGREEMENT SETS FORTH THE
    ENTIRE AGREEMENT AND UNDERSTANDING OF THE PARTIES RELATING TO THE
    SUBJECT MATTER HEREIN AND MERGES AND SUPERSEDES ALL PRIOR AGREEMENTS,
    DISCUSSIONS, AND UNDERSTANDINGS BETWEEN THEM.</p>
    <p>
    <u><b>22.
    Basis of Bargain.</b></u></p>
    <p>
    The limited
    warranty, exclusive remedies and limited liability set forth herein
    are fundamental elements of the basis of the bargain between Bella
    Club and you. Bella Club would not be able to provide the Affiliate
    Program on an economic basis without such limitations. 
    </p>
    <p>
    <u><b>23.
    Attorney\'s Fees.</b></u></p>
    <p>
    If any action
    or proceeding shall be commenced to enforce this Agreement or any
    right arising in connection with this Agreement, the prevailing party
    in such action or proceeding shall be entitled to recover from the
    other party the reasonable costs, expenses and attorney\'s fees (and
    all related costs and expenses) incurred by such prevailing party in
    connection with such action or proceeding.</p>
    <p>
    <u><b>24.
    Governing Law.</b></u></p>
    <p>
    This Agreement
    will be governed by the laws of Brazil and the state of Santa
    Catarina, without reference to rules governing choice of laws or
    convenience of forum. Any action relating to this Agreement must be
    brought in the federal or state courts located in Florianópolis,
    and you irrevocably consent to the jurisdiction of such courts. You
    agree to accept service by process of mail.</p>
    <p>
    <u><b>25.
    Notices.</b></u></p>
    <p>
    Notices are
    effective if provided in writing to the postal addresses,
    electronically to the e-mail address set forth in the application or
    if posted on our website. Notice to us may be made in writing to
        Bella Entertainment Ltd. R. Jerônimo Coelho, 383 – 506 –
    Centro – Florianópolis – SC – 88025-000 or
    by e-mail at the contact in our webpage: www.bellaclub.com</p>
    <p>
    <u><b>26.
    Assignment.</b></u></p>
    <p>
    You may not
    assign this Agreement, by operation of law or otherwise, without our
    prior written consent. Subject to that restriction, this Agreement
    will be binding on and enforceable against the parties and their
    respective successors and assigns.</p>
    <p><a name="_GoBack"></a>
    <u><b>27.
    Dispute Resolution.</b></u>

    </p>
    <p>
    The parties
    will attempt in good faith to resolve through negotiation any
    dispute, claim or controversy arising out of or relating to this
    Agreement. Either party may provide written notice in letter form to
    the other party, setting forth the subject of the dispute and the
    relief requested. If the dispute is not resolved by negotiations, the
    matter will be resolved by the courts of law in Florianópolis,
    Santa Catarina. The provisions of this Section may be enforced by any
    Court of competent jurisdiction, and the party seeking enforcement
    shall be entitled to an award of all costs, fees and expenses,
    including attorneys fees, to be aid by the party against whom
    enforcement is ordered. The substantive laws of the State of Santa
    Catarina shall be applied. Notwithstanding anything to the contrary,
    nothing set forth in this Dispute Resolution Section shall prevent
    either party from seeking injunctive relief in any court of competent
    jurisdiction to protect its interest pending the resolution of a
    dispute. 
    </p>`,
    html: `On air since 2001, BellaClub is one of the most famous and renowned sites of sexy photo shoots on the net. It is easy to win some extra money with us! We offer you a cost-free partnership which guarantees you fixed commission fees.
                <br>

                Our Affiliate Program works this way:
                <br>
                <br>

                <h3>Register</h3>
                To become a Bella Club partner, first you need to register. Once you have your registration approved, you will get an automatic link which shall be added to your website in a banner or as a link.
                <br>
                <br>

                Every time a user is directed to Bella Club by using the link you posted on your website, he gets a permanent cookie which will identify him as a client who came to us as your indication.
                <br>
                <br>

                The more clicks you get, the higher the chances of a visitor becoming a Bella Club member and you getting your money. For every membership generated by your link, you get a 50% of the plan cost commissioned.
                <br>
                <br>

                <h3>Payment</h3>

                Payments are cumulative and paid to you on the 7th of each month via PayPal (If you still don´t have an account with them, you will need to subscribe – it´s free!). In case you don´t have at least $50 at the end of the month, the amount accumulates until you get the minimum value and then you receive it all into your PayPal account. 
                <br>
                <br>

                <h3>Control</h3>
                So you have control and are able to follow the memberships you´ve generated step-by-step, you will have access to a link which is for partners only. There, it is possible to check all the information generated by the link you posted on your website, such as sales reports, the quantity of clicks generated by you and the amount of memberships sold.
                <br>
                <br>

                <h3>Questions?</h3>
                Please read our FAQ for more information or contact us by filling up our <a href="/pt-br/programa-afiliados/subscribe">contact form</a>.
                <br>`
  }
}

export default translate
